module.exports = __webpack_public_path__ + "static/media/mainpic.268112a8.png";